/**
 * Raised when an RFP invite request fails auth without the expired-token signal
 * (e.g. a legacy bare link_uuid bookmark with no All-In-One credential).
 */
export class UnauthorizedInviteError extends Error {
  constructor() {
    super('Unauthorized invite.')
    this.name = 'UnauthorizedInviteError'
  }
}
